export enum ConnectBankModalStateId {
  ConnectBank = 'connectBank',
  ImportCsv = 'importCsv',
}
